import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TxnService } from 'app/services/txn.service';

/**
 * 錯誤彈窗元件
 * 用於在新視窗中顯示錯誤訊息，模擬原始的簡單錯誤顯示方式
 */
@Component({
  selector: 'app-error-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.css']
})
export class ErrorPopupComponent implements OnInit {
  errorMessage: string = '';

  constructor(private route: ActivatedRoute, public txnService: TxnService) { }

  ngOnInit() {
    // 從 URL 參數取得錯誤 ID
    this.route.queryParams.subscribe(params => {
      if (params['errorId']) {
        this.loadErrorFromStorage(params['errorId']);
      } else {
        this.errorMessage = this.txnService.transform('未知的錯誤', 'common00004655', null);
      }
    });

    // 設定視窗標題
    document.title = this.txnService.transform('Error', 'common00004656', null);
  }



  /**
   * 從 SessionStorage 載入錯誤訊息
   * @param errorId 錯誤訊息 ID
   */
  private loadErrorFromStorage(errorId: string): void {
    try {
      const errorDataStr = sessionStorage.getItem(errorId);
      if (errorDataStr) {
        const errorData = JSON.parse(errorDataStr);
        this.errorMessage = this.processErrorMessage(errorData.message || this.txnService.transform('未知的錯誤', 'common00004655', null));

        // 立即清理該錯誤訊息（確保顯示後就刪除）
        sessionStorage.removeItem(errorId);

      } else {
        this.errorMessage = this.txnService.transform('錯誤訊息已過期或不存在', 'common00004657', null);
      }
    } catch (e) {
      this.errorMessage = this.txnService.transform('載入錯誤訊息時發生問題', 'common00004658', null);
    }
  }



  /**
   * 處理錯誤訊息，支援 JSON 格式的錯誤
   */
  private processErrorMessage(errorMsg: string): string {
    try {
      const errorObj = JSON.parse(errorMsg);

      if (errorObj.errorDesc) {
        return errorObj.errorDesc;
      }

      if (errorObj.message) {
        return errorObj.message;
      }

      // 如果是 JSON 但沒有特定欄位，返回原始訊息
      return errorMsg;
    } catch (e) {
      // 不是 JSON 格式，直接返回原始訊息
      return errorMsg;
    }
  }



}
